import { appSwitcherFeature } from '@app/portal/app-switcher/+state/app-switcher.reducer';

export const { selectSelectedCategory: selectAppSwitcherCategory } = appSwitcherFeature;
